import ReactSwitch from 'react-switch'

type SwitchProps = {
  id?: string
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

function Switch({ id, checked = false, onCheckedChange, disabled, className }: SwitchProps) {
  return (
    <ReactSwitch
      id={id}
      checked={checked}
      onChange={(val) => onCheckedChange?.(val)}
      disabled={disabled}
      onColor="#7c3aed"
      offColor="#d1d5db"
      handleDiameter={16}
      height={20}
      width={36}
      checkedIcon={false}
      uncheckedIcon={false}
      activeBoxShadow="0 0 2px 3px rgba(124, 58, 237, 0.3)"
      className={className}
    />
  )
}

export { Switch }
export type { SwitchProps }
